import { defineMessages, IntlShape } from "react-intl";

import { CustomMetricAggregation } from "@mapmycustomers/shared/types/stackRank/CustomMetric";

import { getDisplayName } from "./getDisplayName";

const messages = defineMessages<CustomMetricAggregation>({
  avg: {
    id: "customMetricAggregation.avg",
    defaultMessage: "Average",
  },
  sum: {
    id: "customMetricAggregation.sum",
    defaultMessage: "Sum",
  },
});

const getCustomMetricAggregationDisplayName = (
  intl: IntlShape,
  aggregation: CustomMetricAggregation
) => getDisplayName(intl, messages, aggregation, "CustomMetricAggregation");

export default getCustomMetricAggregationDisplayName;
